import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import { FiExternalLink, FiShare } from 'react-icons/fi';

import { NavBackButton, SidebarHeader } from '@mssgme/ui';
import styles from './styles.scss';

export const PreviewModal = ({ isShowing, toggle, pageUrl }) => {
    const { t } = useTranslation('cards');

    if (isShowing) {
        return ReactDOM.createPortal(
            <div className={styles.root}>
                <SidebarHeader
                    heading={t('PreviewModal.heading')}
                    leftButton={<NavBackButton tag="div" onClick={toggle} />}
                    rightButton={
                        <div className={styles.headerBtns}>
                            <a className={styles.headerLink} href={pageUrl} target="_blank" rel="noopener noreferrer">
                                <FiExternalLink size={22} color="#000" />
                            </a>
                            {'share' in navigator && (
                                <div className={styles.headerLink}>
                                    <FiShare size={22} color="#000" onClick={() => navigator.share({ url: pageUrl })} />
                                </div>
                            )}
                        </div>
                    }
                />
                <div className={styles.content}>
                    <iframe className={styles.iframe} src={pageUrl} frameBorder="0" />
                </div>
            </div>,
            document.body
        );
    }

    return null;
};
